<template>
  <div>
    <div v-if="isBusy || loading" class="text-center text-danger my-2">
      <b-spinner class="align-middle"></b-spinner>
      <strong class="ml-1">{{ $t('CATALOG_LOADING_LABEL', {catalog: $t('USERS')})  | capitalize}}</strong>
    </div>
    <b-card bg-variant="dark" text-variant="light" v-else :title="$t('USERS') | capitalize">
      <b-card-text>
        <b-button id="open-user-selector-button" class="mb-2" variant="info" @click="showModal">
          {{ $t('FORMS_MULTI_SELECT_LABEL', {catalog: $t('USERS')})  | capitalize}}
        </b-button>
        <b-list-group>
          <b-list-group-item variant="dark" :key="user.id" v-for="user of current">{{ user.fullName  | capitalize}}
          </b-list-group-item>
        </b-list-group>
        <b-modal :title="$t('FORMS_MULTI_SELECT_LABEL', {catalog: $t('USERS')})  | capitalize" id="modal" size="xl" @ok="handleInput">
          <user-list
              :organizations="organizations"
              :owner-organization="ownerOrganization"
              :only-active="true"
              :currently-selected="currentHrefs"
              :filterBy="filterBy"
              @change="storeSelected"></user-list>
        </b-modal>
      </b-card-text>
    </b-card>
  </div>
</template>

<script>
import {LoadData, SendsMessages, VModel} from "@/mixins";
import UserList from "@/users/UserList";

export default {
  name: "UserSelector",
  components: {UserList},
  props: ['filterBy', 'loading', 'value', 'initialValues', 'organizations', 'ownerOrganization'],
  mixins: [LoadData, VModel, SendsMessages],
  mounted() {
    this.currentHrefs = this.value;
    this.current = this.initialValues;
  },
  watch: {
    value(val) {
      this.currentHrefs = val;
    },
    initialValues(val) {
      this.current = val;
    }
  },
  methods: {
    storeSelected(selected) {
      this.selected = selected;
      this.selectedHrefs = selected.map(x => x._links.self.href);
    },
    async showModal() {
      this.$bvModal.show('modal');
    },
    handleInput() {
      this.$emit('input', this.selectedHrefs);
      this.current = this.selected;
      this.currentHrefs = this.current.map(x => x._links.self.href)
      this.selected = [];
      this.selectedHrefs = [];
    }
  },
  data() {
    return {
      search: '',
      users: [],
      content: this.value,
      selected: [],
      selectedHrefs: [],
      current: [],
      currentHrefs: []
    }
  },
}
</script>

<style scoped>

</style>
